import { useMutation, useQueryClient } from 'react-query'
import { SetUserCurrentOfficeResult, User } from '@dc-shared-web/hooks/api/user'
import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'
import {
  setUserCurrentOffice,
  SetUserCurrentOfficeParams,
} from '@dc-shared-web/hooks/api/user/setUserCurrentOffice'

export const useSetUserCurrentOffice = (params?: {
  onSuccess?: (result: SetUserCurrentOfficeResult) => void
}) => {
  const apiClient = useAxiosContext()
  const queryClient = useQueryClient()

  return useMutation(
    ({ teamId }: SetUserCurrentOfficeParams) =>
      setUserCurrentOffice(apiClient, teamId),
    {
      onSuccess: async (result) => {
        // This is causing a flash in the app because it's triggering a refretch of the User which causes the auth provider to change.
        // In this specific scenario we might need to manually update the user cache (somehow?).
        await queryClient.invalidateQueries<User>(`User`, {
          refetchActive: true,
          refetchInactive: true,
        })

        params?.onSuccess?.(result)
      },
    }
  )
}
